import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Layout, Menu } from 'antd';
import SubMenu from 'antd/lib/menu/SubMenu';
import setSizeSidebar from '../../../redux/actions/sidebar';
import Logo from '../../../assets/images/LogoSVG.svg';
import SmallLogoSVG from '../../../assets/images/SmallLogoSVG.svg';
import usePathname from '../../../helpers/hooks/usePathname';
import style from './Sidebar.module.scss';
import api from '../../../helpers/api';
import isGuidValid from '../../../assets/utils/guids/helpers/isGuidValid';
import { GUIDKEYS } from '../../../assets/utils/guids/types';
import GarantCheckdocMenuItem from './GarantCheckdocMenuItem';

const Sidebar: React.FC = () => {
  const { Sider } = Layout;
  // @ts-ignore
  const user = useSelector((state) => state.user.userData);

  const [collapsed, setCollapsed] = useState(false);
  const [menuItems, setMenuItems] = useState<Array<any>>([]);
  // const [sectionId, setSectionId] = useState<any>(null);
  const dispatch = useDispatch();
  const onCollapse = (state: boolean) => {
    setCollapsed(state);
  };

  React.useEffect(() => {
    (async () => {
      // // Получаем номер секции
      // await fetch('/api/auth/me')
      //   .then((data) => data.json())
      //   .then((data) => setSectionId(data.sectionId));
      const res = await api.getMenuItems();
      setMenuItems(res.availablePages);
    })();
  }, []);

  const triggerSidebar = () => {
    setCollapsed((prev) => !prev);
    dispatch(setSizeSidebar(!collapsed));
  };

  return (
    <Sider
      id="sidebar"
      width="280px"
      collapsible
      collapsed={collapsed}
      onCollapse={onCollapse}
      className={collapsed ? `${style.sidebar} ${style.collapsedSidebar}` : style.sidebar}
    >
      <header>
        <div className={collapsed ? style.headerClose : style.headerOpen}>
          <div className={style.logoWrapper}>
            <img src={collapsed ? SmallLogoSVG : Logo} alt="Logo" className={style.logo} />
          </div>
          <div
            role="presentation"
            onClick={triggerSidebar}
            className={collapsed ? style.sidebarBtnClose : style.sidebarBtnOpen}
          />
        </div>

        <h2 className={style.description} style={collapsed ? { color: 'white' } : {}}>
          {collapsed ? 'ЦП' : 'Цифровой помощник'}
        </h2>
      </header>

      <Menu
        className={style.menuItemsWrapper}
        theme="light"
        mode="inline"
        activeKey={usePathname()}
        selectedKeys={[usePathname()]}
      >
        <>
          {menuItems && (
            <>
              {menuItems.includes('proverka-kontragenta') && (
                <Menu.Item key="/">
                  <NavLink to="/" className={`${style.navLink} ${style.case}`} activeClassName={style.active} exact>
                    Проверка контрагента
                  </NavLink>
                </Menu.Item>
              )}
              {menuItems.includes('selection-of-suppliers-page') && (
                <Menu.Item key="/selection-of-suppliers-page">
                  <NavLink
                    to="/selection-of-suppliers-page"
                    className={`${style.navLink} ${style.suppliers}`}
                    activeClassName={style.active}
                    exact
                  >
                    Подбор поставщиков на <br />
                    закупку
                  </NavLink>
                </Menu.Item>
              )}
              {menuItems.includes('purchasing-history-page') && (
                <Menu.Item key="/purchasing-history-page">
                  <NavLink
                    to="/purchasing-history-page"
                    className={`${style.navLink} ${style.archive}`}
                    activeClassName={style.active}
                    exact
                  >
                    История участия в торгах
                  </NavLink>
                </Menu.Item>
              )}

              {menuItems.includes('information-of-registration-page') && (
                <Menu.Item key="/information-of-registration-page">
                  <NavLink
                    to="/information-of-registration-page"
                    className={`${style.navLink} ${style.registration}`}
                    activeClassName={style.active}
                    exact
                  >
                    Проверка регистрации на <br /> ЭТП ТЭК-Торг
                  </NavLink>
                </Menu.Item>
              )}

              <GarantCheckdocMenuItem />

              {menuItems.includes('nmc') && (
                <SubMenu className={`${style.nmcSubMenu} ${style.nmc}`} title={!collapsed ? 'Обоснование НМЦ' : null}>
                  <Menu.ItemGroup>
                    {menuItems.includes('nmc-okpd2') && (
                      <NavLink to="/nmc/okpd2" className={`${style.subMenuLink}`} activeClassName={style.active} exact>
                        ОКПД 2/КТРУ
                      </NavLink>
                    )}

                    {menuItems.includes('nmc-nmck') && (
                      <NavLink to="/nmc/nmck" className={`${style.subMenuLink}`} activeClassName={style.active} exact>
                        НМЦК
                      </NavLink>
                    )}

                    {menuItems.includes('nmc-skp') && (
                      <NavLink to="/nmc/skp" className={`${style.subMenuLink}`} activeClassName={style.active} exact>
                        Расчет сроков
                      </NavLink>
                    )}

                    {menuItems.includes('nmc-purchases-docs') && (
                      <NavLink
                        to="/nmc/purchases-docs"
                        className={`${style.subMenuLink}`}
                        activeClassName={style.active}
                        exact
                      >
                        Поиск документации
                      </NavLink>
                    )}

                    {menuItems.includes('nmc-pending-purchases') && (
                      <NavLink
                        to="/nmc/pending-purchases"
                        className={`${style.subMenuLink}`}
                        activeClassName={style.active}
                        exact
                      >
                        Текущие закупки
                      </NavLink>
                    )}

                    {menuItems.includes('nmc-contracts-registry') && (
                      <NavLink
                        to="/nmc/contracts-registry/summary"
                        className={`${style.subMenuLink}`}
                        activeClassName={style.active}
                        exact
                      >
                        Реестр Закупок
                      </NavLink>
                    )}
                    <NavLink
                      to="/nmck/nmck-gsm"
                      className={`${style.subMenuLink}`}
                      activeClassName={style.active}
                      exact
                    >
                      Расчет НМЦК на ГСМ
                    </NavLink>
                    <NavLink
                      to="/nmck/nmck-guard"
                      className={`${style.subMenuLink}`}
                      activeClassName={style.active}
                      exact
                    >
                      Расчет НМЦК на услуги охраны
                    </NavLink>
                    <NavLink
                      to="/nmck/nmck-med"
                      className={`${style.subMenuLink}`}
                      activeClassName={style.active}
                      exact
                    >
                      Расчет НМЦК на медицинские изделия
                    </NavLink>
                    <NavLink
                      to="/nmck/nmck-drugs"
                      className={`${style.subMenuLink}`}
                      activeClassName={style.active}
                      exact
                    >
                      Расчет НМЦК на лекарственные препараты
                    </NavLink>
                  </Menu.ItemGroup>
                </SubMenu>
              )}

              {menuItems.includes('tru') && (
                <Menu.Item key="/tru">
                  <NavLink to="/tru" className={`${style.navLink} ${style.tru}`} activeClassName={style.active} exact>
                    Единичные расценки ТРУ Интернет-магазина
                  </NavLink>
                </Menu.Item>
              )}
              {isGuidValid(user, GUIDKEYS.RNKIM) && (
                <Menu.Item key="/rnkim">
                  <NavLink
                    to="/rnkim"
                    className={`${style.navLink} ${style.rnkim}`}
                    activeClassName={style.active}
                    exact
                  >
                    Отчет по контрагентам РН+КИМ
                  </NavLink>
                </Menu.Item>
              )}
              {isGuidValid(user, GUIDKEYS.ZAKUPKI_ROSNEFT) && (
                <Menu.Item key="/zakupki_rosneft">
                  <NavLink
                    to="/zakupki_rosneft"
                    className={`${style.navLink} ${style.zakupki_rosneft}`}
                    activeClassName={style.active}
                    exact
                  >
                    Закупочные процедуры ПАО &quot;НК Роснефть&quot;
                  </NavLink>
                </Menu.Item>
              )}
              {isGuidValid(user, GUIDKEYS.REPORT_REGION) && (
                <Menu.Item key="/rn-region-report">
                  <NavLink
                    to="/rn-region-report"
                    className={`${style.navLink} ${style.rnkim}`}
                    activeClassName={style.active}
                    exact
                  >
                    Отчет по регионам
                  </NavLink>
                </Menu.Item>
              )}
            </>
          )}
          {!!user?.additionalData?.kupec && (
            <Menu.Item key="/offers-request">
              <NavLink
                className={`${style.navLink} ${style.rnkim}`}
                activeClassName={style.active}
                exact
                to="/offers-request"
              >
                Поиск ценовых предложений
              </NavLink>
            </Menu.Item>
          )}
        </>
        {isGuidValid(user, GUIDKEYS.KIM) && (
          <SubMenu
            key="kim-submenu"
            className={`${style.nmcSubMenu} ${style.nmc}`}
            title={!collapsed ? 'Отчет по закупкам КИМ' : null}
          >
            <Menu.ItemGroup>
              <NavLink to="/kim-summary" className={`${style.subMenuLink}`} activeClassName={style.active} exact>
                Общие итоги по закупкам КИМ
              </NavLink>
              <NavLink
                to="/kim-customers-dynamics"
                className={`${style.subMenuLink}`}
                activeClassName={style.active}
                exact
              >
                Заказчики+динамика КИМ
              </NavLink>
              <NavLink
                to="/kim-suppliers-dynamics"
                className={`${style.subMenuLink}`}
                activeClassName={style.active}
                exact
              >
                Поставщики+динамика КИМ
              </NavLink>
              <NavLink
                to="/kim-customers-suppliers"
                className={`${style.subMenuLink}`}
                activeClassName={style.active}
                exact
              >
                Заказчики + поставщики КИМ
              </NavLink>
            </Menu.ItemGroup>
          </SubMenu>
        )}
        <footer className={style.contacts}>
          <div className={style.contactPhones}>
            <Menu.Item key="1">
              <a className={`${style.link} ${style.phone}`} href="tel:+7(495)734-81-18">
                +7(495)734-81-18
              </a>
            </Menu.Item>
            <Menu.Item key="2">
              <a className={`${style.link} ${style.phone}`} href="tel:+7(499)705-81-18">
                +7(499)705-81-18
              </a>
            </Menu.Item>
          </div>
          <div className={style.otherContacts}>
            <Menu.Item key="4">
              <a className={`${style.link} ${style.mail}`} href="mailto:help@tektorg.ru">
                help@tektorg.ru
              </a>
            </Menu.Item>
          </div>
        </footer>
      </Menu>
    </Sider>
  );
};
export default Sidebar;
